import type { OrganizationTypeWithLinkedProfessions } from '@common/enums';
import type { Profession } from '@common/enums/profession';
import {
    isIdentifierDeclarationAllowed,
    isIdentifierDeclarationOrSupervisorRequired,
    isIdentifierDeclarationRequired,
    isIdentifierRegistrationBigAllowed,
    isIdentifierRegistrationKpAllowed,
    isSpecialismRequired,
    isSupervisorAllowed,
    isSupervisorRequired,
    isZorgmailNummerAllowed,
    isZorgmailNummerRequired,
} from './practitionerIdentifiersHelpers';

export interface FieldRequirementsBasedOnProfession {
    isAgbCodeAllowed: boolean;
    isAgbCodeOrSupervisorRequired: boolean;
    isAgbCodeRequired: boolean;
    isIdentifierRegistrationBigRequired: boolean;
    isIdentifierRegistrationKpRequired: boolean;
    isSpecialismFieldRequired: boolean;
    isSupervisorAllowed: boolean;
    isSupervisorRequired: boolean;
    isZorgmailNummerFieldAllowed: boolean;
    isZorgmailNummerFieldRequired: boolean;
}

export const fieldRequirementsBasedOnProfessionInitialState: FieldRequirementsBasedOnProfession = {
    isAgbCodeAllowed: false,
    isAgbCodeOrSupervisorRequired: false,
    isAgbCodeRequired: false,
    isIdentifierRegistrationBigRequired: false,
    isIdentifierRegistrationKpRequired: false,
    isSpecialismFieldRequired: false,
    isSupervisorAllowed: false,
    isSupervisorRequired: false,
    isZorgmailNummerFieldAllowed: false,
    isZorgmailNummerFieldRequired: false,
};

export function checkRequiredAndAllowedAccountCreationFieldsPerProfession(
    profession: Profession | null,
    organizationType: OrganizationTypeWithLinkedProfessions | null
): FieldRequirementsBasedOnProfession {
    const selectedProfessionArray = profession ? [profession] : undefined;

    const isAgbCodeRequiredForProfession = isIdentifierDeclarationRequired(selectedProfessionArray, organizationType);

    const isAgbCodeAllowedForProfession = isIdentifierDeclarationAllowed(selectedProfessionArray, organizationType);

    const isIdentifierRegistrationBigForProfession = isIdentifierRegistrationBigAllowed(
        selectedProfessionArray,
        organizationType
    );

    const isSupervisorRequiredForProfession = isSupervisorRequired(selectedProfessionArray, organizationType);

    const isSupervisorAllowedForProfession = isSupervisorAllowed(selectedProfessionArray, organizationType);

    const isAgbCodeOrSupervisorRequiredForProfession = isIdentifierDeclarationOrSupervisorRequired(
        selectedProfessionArray,
        organizationType
    );

    const isZorgmailNummerFieldRequiredForProfession = isZorgmailNummerRequired(
        selectedProfessionArray,
        organizationType
    );

    const isZorgmailNummerFieldAllowedForProfession = isZorgmailNummerAllowed(
        selectedProfessionArray,
        organizationType
    );

    const isIdentifierRegistrationKpRequiredForProfession = isIdentifierRegistrationKpAllowed(
        selectedProfessionArray,
        organizationType
    );

    const isSpecialismRequiredForProfession = isSpecialismRequired(profession);

    return {
        isAgbCodeAllowed: isAgbCodeAllowedForProfession,
        isAgbCodeOrSupervisorRequired: isAgbCodeOrSupervisorRequiredForProfession,
        isAgbCodeRequired: isAgbCodeRequiredForProfession,
        isIdentifierRegistrationBigRequired: isIdentifierRegistrationBigForProfession,
        isIdentifierRegistrationKpRequired: isIdentifierRegistrationKpRequiredForProfession,
        isSpecialismFieldRequired: isSpecialismRequiredForProfession,
        isSupervisorAllowed: isSupervisorAllowedForProfession,
        isSupervisorRequired: isSupervisorRequiredForProfession,
        isZorgmailNummerFieldAllowed: isZorgmailNummerFieldAllowedForProfession,
        isZorgmailNummerFieldRequired: isZorgmailNummerFieldRequiredForProfession,
    };
}
